import {get} from '@stencil/megatron';
import {apiConfig} from '@stencil/hotels-config';
import {getMAPIBaseUrl} from '@stencil/hotels-utils/src/common-utils';

export async function getPlaceDetailsFromCoordinates({
  latitude = '',
  longitude = '',
  placeId = '',
}) {
  let query = '';
  if (placeId) {
    query = `placeid=${placeId}`;
  } else if (latitude && longitude) {
    query = `lat=${latitude}&lng=${longitude}`;
  }
  const url = `${getMAPIBaseUrl()}${apiConfig.__autosuggestGetPlaceDetails__}?${query}`;
  try {
    const {data} = await get(url, {name: 'location fetching API "get-place-details"'});
    if (!data.success) {
      return null;
    }
    return data?.response;
  } catch (err) {
    console.trace(err);
    return null;
  }
}

export default getPlaceDetailsFromCoordinates;
